import React from "react";
import { Helmet } from "react-helmet";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import { comapnyCtaContent } from "../data/hireFlutterPageData";
import { hireDataScientestPageContent } from "../data/hire-data-scientest";
import HirePageTestimonial from "../components/hire-page-testimonial/HirePageTestimonial";
import NewTeamSection from "../components/new-team-section/NewTeamSection";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import ChallengeSection from "../components/challenge-section/ChallengeSection";
import HirePageSolutionSection from "../components/hire-page-solution-section/HirePageSolutionSection";
import NewCtaSection from "../components/new-cta-section/NewCtaSection";

const HireDataScientestPage = () => {

    return (
        <>
            <Helmet>
                <title>Hire Data Scientists & Engineers | Analytics & Big Data Experts at Bitsclan</title>
                <meta name="description" content="Hire US-based Data Scientists and Data Engineers to unlock actionable insights, big data analytics, and predictive modeling for your business. Bitsclan connects B2B companies to top analytics and engineering talent fast, secure, and scalable." />
            </Helmet>

            <MegaMenu />

            <ServicesPageBanner
                shortHeading={hireDataScientestPageContent?.mainBanner?.shortHeading}
                mainHeading={hireDataScientestPageContent?.mainBanner?.mainHeading}
                description={hireDataScientestPageContent?.mainBanner?.content}
            />
            <TrustedPartner heading="Trusted & Partnered by Businesses Worldwide to Build High Performance Machine Learning Solutions" />

            <OurServices
                shortHeading={hireDataScientestPageContent?.flutterExpertise?.shortHeading}
                mainHeading={hireDataScientestPageContent?.flutterExpertise?.heading}
                description={hireDataScientestPageContent?.flutterExpertise?.description}
                servicesCardsData={hireDataScientestPageContent?.flutterExpertise?.servicesData}
                buttonText="Start Your Project"
            />

            <HirePageTestimonial
                shortHeading="Some of Our Happy Clients"
                mainHeading="Trusted <span>Partnerships.</span> Proven Data Excellence"
                description="Clients partner with us for transparency, reliability, and measurable impact. Our Data Scientists and Engineers deliver insight-driven systems designed for scalability, speed, and long-term business value."
                testimonials={hireDataScientestPageContent?.testimonialsData}
            />

            <NewTeamSection
                shortHeading={"Our Team"}
                mainHeading={"Introducing Our Expert Data Science Team"}
                description={"Our specialized Data Scientists and Engineers manage every stage, from data collection and model development to deployment and real-time analytics, delivering scalable solutions that turn data into actionable insights and drive business growth."}
            />

            <NewCtaSection content={hireDataScientestPageContent?.ctaSection} />

            {/* <NewTestimonials
                shortHeading=" Some of Our Happy Clients"
                mainHeading="What Our Clients Say About Bitsclan's <span>Flutter Expertise</span>"
                description="We take pride in our flutter app development services, earning positive feedback from clients who value our dedication, quality, & reliable results. Their satisfaction inspires us to deliver exceptional mobile solutions every time."
            /> */}

            <NewCaseStudySection
                shortHeading="Our Clients Journey"
                heading="Transforming Data into Business Growth with Data Science Solutions"
                description="Explore how our Data Scientists and Engineers help businesses turn complex data into actionable insights, optimize workflows, and drive predictive modeling and real-time analytics, resulting in enhanced performance and measurable business outcomes across industries."
            />

            {/* <DevelopmentPerformance
        buttonText={whyChooseUs.btnText}
        heading={whyChooseUs.heading}
        greenHeading={whyChooseUs.greenHeading}
        subHeading={whyChooseUs.subHeading}
        solutions={whyChooseUs.solutionsData}
      /> */}

            <HireCombinationSection
                shortHeading={hireDataScientestPageContent?.techCombinations?.shortHeading}
                combinations={hireDataScientestPageContent?.techCombinations?.combinations}
                heading={hireDataScientestPageContent?.techCombinations?.heading}
                description={hireDataScientestPageContent?.techCombinations?.description}
            />

            <WhyChooseBitsclan
                tabs={hireDataScientestPageContent?.whyChooseBitsclanContet}
                expandAllAccordions={true}
                shortHeading={"How We Work"}
                heading={"Here’s why leading companies trust us with their Data Science teams"}
                subheading={"From data collection to real-time analytics, we’ve perfected every stage of our process to deliver actionable insights and measurable business impact. Our approach guarantees transparency, speed, and quality, helping you turn raw data into strategic value faster. <br/> <br/> With us, you get a reliable data science partner focused on performance, efficiency, and transformational success."}
                ctaText={"Contact Our Experts"}
            />

            <SimpleModels content={hireDataScientestPageContent?.engagementModels} />

            <CoverTheStack
                shortHeading={"Our Tech Stacks"}
                whereStart={"Languages & Frameworks"}
                mainHeading={"Comprehensive Machine Learning Expertise"}
                subHeading={"Our engineers utilize a modern tech stack designed for scalability, performance, and real-world impact. With hands-on experience across 100+ tools and frameworks, we provide end-to-end ML solutions from data engineering and model development to deployment, monitoring, and continuous optimization."}
                tabs={hireDataScientestPageContent?.coverTheStack.tabs}
                tabItems={hireDataScientestPageContent?.coverTheStack.tabItems}
            />

            <HirePageSteps
                buttonText={hireDataScientestPageContent?.hireSteps.btnText}
                heading={hireDataScientestPageContent?.hireSteps.heading}
                subHeading={hireDataScientestPageContent?.hireSteps.subHeading}
                steps={hireDataScientestPageContent?.hireSteps.steps}
            />

            <ChallengeSection
                mainHeading={"Top Challenges in Data Hiring & Development"}
                description={"Top Challenges in Data Science Implementation"}
                content={hireDataScientestPageContent?.challengesData}
            />

            <HirePageSolutionSection
                shortHeading="Machine Learning Solutions We Build"
                mainHeading="How We Solve Machine Learning Challenges"
                description="We simplify the process of managing, scaling, and optimizing Machine Learning teams. Our approach tackles every challenge  from onboarding to deployment ensuring that your projects move seamlessly from concept to production with measurable success."
                content={hireDataScientestPageContent?.mlSolutionsData}
            />

            <WhyChooseUs
                heading={hireDataScientestPageContent?.whyUsContent?.heading}
                greenHeading={hireDataScientestPageContent?.whyUsContent?.greenHeading}
                shortHeading={hireDataScientestPageContent?.whyUsContent?.shortHeading}
                content={hireDataScientestPageContent?.whyUsContent?.content}
                stats={hireDataScientestPageContent?.whyUsContent?.stats}
                cta={hireDataScientestPageContent?.whyUsContent?.cta}
                sectionImage={hireDataScientestPageContent?.whyUsContent?.image}
            />

            {/* <HireExpertFacts
        buttonText={expertFacts.btnText}
        heading={expertFacts.heading}
        greenHeading={expertFacts.greenHeading}
        facts={expertFacts.facts}
        diffBannerBackgroundImage={expertFacts.backgroundImage}
      />

      <HirePageAppIdea
        heading={appIdeaSection?.heading}
        content={appIdeaSection.content}
      /> */}

            {/* <HirePageEngagmentModels
        buttonText={hirePageEngagementModels.btnText}
        heading={hirePageEngagementModels.headingContent}
        content={hirePageEngagementModels.discription}
        hiringDetails={hirePageEngagementModels.hiringDetails}
      /> */}

            {/* <SimpleModels content={engagementModelsContent} /> */}

            <TrendsInsights heading="Only show blogs related to AI/ML" description="Here’s the revised version of the Machine Learning FAQs section, with the word 'hire' replaced and the content focused on business impact" specificClass="mobile-dev-page" category="all" />

            {/* <SecondFaq
                specificClass="mobile-dev-page"
                faqs={hireDataScientestPageContent?.faqSection.faqData}
                mainHeading={hireDataScientestPageContent?.faqSection.mainHeading}
                subHeading={hireDataScientestPageContent?.faqSection.subHeading}
            /> */}

            {/* <ContactSection /> */}

            <SoftwareCompanyCta content={comapnyCtaContent} />

            <Footer />
        </>
    );
};

export default HireDataScientestPage;